import * as React from "react";

const Arrow = (props) => (
  <div className="w-[50px] h-[50px] flex items-center jusitfy-evenly">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill={props.dark ? "white" : "black"}>
        <path
          fillRule="evenodd"
          d="M5.604 4.23A1 1 0 0 0 4 5.029v13.944a1 1 0 0 0 1.604.797l9.191-6.972a1 1 0 0 0 0-1.594l-9.19-6.972ZM2 5.029c0-2.48 2.838-3.89 4.813-2.39l9.191 6.972a3 3 0 0 1 0 4.78l-9.19 6.973C4.837 22.86 2 21.453 2 18.973V5.027Z"
          clipRule="evenodd"
        />
        <path d="M20 3a1 1 0 1 1 2 0v18a1 1 0 1 1-2 0V3Z" />
      </g>
    </svg>
  </div>
);
export default Arrow;
